import React from "react";
import PropTypes from "prop-types";

import { buildSearchPlaceholder } from "shared/utils/search";
import SearchInput from "../SearchInput/SearchInput";

const SearchBar = ({
  value,
  onChange,
  searchableFields,
  fieldLabels,
  placeholder,
  disabled = false,
  className,
  id,
  name,
  onKeyDown,
}) => {
  const resolvedPlaceholder =
    placeholder ?? buildSearchPlaceholder(searchableFields, fieldLabels);

  return (
    <SearchInput
      id={id}
      name={name}
      className={className}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={resolvedPlaceholder}
      disabled={disabled}
    />
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  searchableFields: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  ),
  fieldLabels: PropTypes.objectOf(PropTypes.string),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onKeyDown: PropTypes.func,
};

export default SearchBar;
